import { Transforms, Path, Editor } from 'slate';
import type { TextBlock } from '@atlas/tool/box/slate/isTextBlock';

export default function normalizeTextBlock(editor: Editor, node: TextBlock, path: Path) {
    if (!node.children?.length) {
        Transforms.insertNodes(editor, [{ text: '' }], { at: path.concat(0) });
    }
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('normalizeTextBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
